<script lang="ts" setup>
import useMagnoliaContext from "~/composables/useMagnoliaContext";
const { isMagnoliaEdit } = useMagnoliaContext();
</script>

<template>
  <template v-if="isMagnoliaEdit">
    <slot />
  </template>
</template>
